module.exports = __webpack_public_path__ + "static/media/brand-lift.ba7b1464.png";